import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { checkLogin, checkIdleTimeout, updateLastActivity } from '../redux/actions/auth'
import Loading from './Loading'
import Login from './Login'

// DOM events that count as user activity for the idle timeout
const ACTIVITY_EVENTS = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart', 'click']
// How often to check whether the session has gone idle (ms)
const IDLE_CHECK_INTERVAL_MS = 60 * 1000

/**
 * Ensures the user is logged in when mounting the WrappedComponent
 * @param {*} WrappedComponent
 */
export default function(WrappedComponent) {
  class Authenticate extends React.Component {
    static propTypes = {
      checkLogin:       PropTypes.func.isRequired,
      checkIdleTimeout: PropTypes.func.isRequired,
      loggingIn:        PropTypes.bool.isRequired,
      loggedIn:         PropTypes.bool.isRequired,
    }

    componentDidMount() {
      this.props.checkLogin()
      // Record that the user is present right now, then keep tracking
      updateLastActivity()
      ACTIVITY_EVENTS.forEach((evt) =>
        document.addEventListener(evt, this.handleActivity, { passive: true, capture: true })
      )
      this.idleInterval = setInterval(this.checkIdle, IDLE_CHECK_INTERVAL_MS)
    }

    componentWillUnmount() {
      ACTIVITY_EVENTS.forEach((evt) =>
        document.removeEventListener(evt, this.handleActivity, { capture: true })
      )
      if (this.idleInterval) {
        clearInterval(this.idleInterval)
      }
    }

    handleActivity = () => {
      updateLastActivity()
    }

    checkIdle = () => {
      if (this.props.loggedIn) {
        this.props.checkIdleTimeout()
      }
    }

    render() {
      const { loggingIn, loggedIn } = this.props
      return (
        <div>
          {loggingIn ? (
            <Loading />
          ) : loggedIn ? (
            <WrappedComponent {...this.props} />
          ) : (
            <Login />
          )}
        </div>
      )
    }
  }

  const mapDispatchToProps = { checkLogin, checkIdleTimeout }
  const mapStateToProps = (state) => ({
    loggingIn: state.auth.loggingIn,
    loggedIn:  state.auth.loggedIn,
  })

  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Authenticate)
}
